<div class="row">
  @if (!environment.sso.enabled) {
    <div class="col-12 col-sm-6">
      <img src="/assets/images/brand/title.png" class="img-fluid img-thumbnail p-0 shadow" />
    </div>
  }
  <div class="col-12 col-sm-6 mx-auto">
    <img src="/assets/images/brand/logo_claim.png" class="d-block img-fluid mt-3 mb-5 logo mx-auto" />

    <h4>{{ "Template.LoginComponent.subHeader_login" | translate }}</h4>
    <form [formGroup]="loginForm" novalidate>
      <div class="form-group">
        <label for="username">{{ "Template.LoginComponent.label_emailAddress" | translate }}</label>
        <input type="text" [class]="{ 'form-control-plaintext': isLegacyLogin, 'form-control': !isLegacyLogin }" id="username" placeholder="{{ 'Template.LoginComponent.placeholder_username' | translate }}" formControlName="username" autocomplete="username" required [readOnly]="isLegacyLogin" (keyup.enter)="precheckLogin()" />
        @if (!loginForm.controls['username'].valid && !loginForm.controls['username'].untouched) {
          <small class="text-danger">{{ "Template.LoginComponent.msg_emailRequired" | translate }}</small>
        }
      </div>
      @if (isLegacyLogin) {
        <div class="form-group">
          <label for="password">{{ "Template.LoginComponent.label_password" | translate }}</label>
          <input type="password" class="form-control" id="password" placeholder="{{ 'Template.LoginComponent.placeholder_password' | translate }}" formControlName="password" autocomplete="current-password" required (keyup.enter)="loginUser()" />
          @if (!loginForm.controls['password'].valid && !loginForm.controls['password'].untouched) {
            <small class="text-danger">{{ "Template.LoginComponent.msg_passwordRequired" | translate }}</small>
          }
        </div>
      }

      @if (!isLegacyLogin) {
        <button (click)="precheckLogin()" class="btn btn-secondary d-block w-100" [disabled]="isLoading || !loginForm.valid" type="button">
          {{ "Template.LoginComponent.btn_next" | translate }}
          @if (isLoading) {
            <fa-icon icon="spinner" animation="spin" class="ml-1"></fa-icon>
          }
        </button>
      }

      @if (isLegacyLogin) {
        <button (click)="loginUser()" class="btn btn-secondary d-block w-100" [disabled]="isLoading || !loginForm.valid" type="button">
          {{ "Template.LoginComponent.btn_login" | translate }}
          @if (isLoading) {
            <fa-icon icon="spinner" animation="spin" class="ml-1"></fa-icon>
          }
        </button>
      }
    </form>

    @if (error && !isLoading) {
      <div class="alert alert-danger mt-3">
        {{ error }}
      </div>
    }

    <p class="text-center mt-3">
      <a class="btn btn-outline-danger btn-sm" href="recover-password">{{ "Template.LoginComponent.btn_forgotPassword" | translate }}</a>
    </p>

    @if (environment.sso.enabled) {
      <div class="sso-box">
        <h5>
          <span>EK Single Sign On</span>
        </h5>
        <div class="row mt-3">
          <div class="col-12 col-sm-4 col-lg-2 align-content-center">
            <img src="/assets/images/sso/sso-badge-sm.png" class="img-fluid" />
          </div>
          <div class="col-12 col-sm-8 col-lg-10">
            <p class="text-justify mb-0">
              <small>{{ "Template.LoginComponent.text_ssoExplanation" | translate }}</small>
            </p>
          </div>
        </div>
      </div>
    }
  </div>
</div>
